<template>
  <div class="batch-edit">
    <div>
      <el-form v-if="form" :model="form" ref="form" label-width="125px" :hide-required-asterisk="false" :disabled="true">
        <div @keyup.enter.stop="save()" style="width: 100%;margin-bottom: 30px">
          <div>
            <p style="font-weight: bold;font-size: 16px">基本信息</p>
          </div>
          <div style="width: 100%;display: flex;justify-content: start;flex-wrap: wrap">
            <el-form-item label="所属考级点">
              <el-input v-model="form.agentName" :maxlength="20" placeholder="" style="background-color: #ffffff"></el-input>
            </el-form-item>
            <el-form-item label="考试名称" prop="batchName">
              <el-input v-model="form.batchName" :maxlength="20" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="订单开始时间" prop="batchName">
              <el-input v-model="form.startTime" :maxlength="20" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="订单结束时间" prop="batchName">
              <el-input v-model="form.endTime" :maxlength="20" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="退款结算开始时间" prop="batchName">
              <el-input v-model="form.refundStartTime" :maxlength="20" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="退款结算结束时间" prop="batchName">
              <el-input v-model="form.refundEndTime" :maxlength="20" placeholder=""></el-input>
            </el-form-item>
          </div>
        </div>
        <div style="width: 100%">
          <div>
            <p style="font-weight: bold;font-size: 16px">线上订单账单</p>
          </div>
          <div style="width: 100%;display: flex;justify-content: start;flex-wrap: wrap;">
            <el-form-item label="线上订单总费用">
              <el-input v-model="form.onlineOrderFee" :maxlength="20" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="线上订单数量">
              <el-input v-model="form.onlineOrderNum" :maxlength="20" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="线上退单总费用">
              <el-input v-model="form.onlineRefundFee" :maxlength="20" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="线上退单数量">
              <el-input v-model="form.onlineRefundNum" :maxlength="20" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="线上服务有效订单数量">
              <el-input v-model="form.onlineServiceNum" :maxlength="20" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="线上服务总费用">
              <el-input v-model="form.serviceTotalFee" :maxlength="20" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="单笔服务费用">
              <el-input v-model="form.serviceFee" :maxlength="20" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="线上有效订单费用">
              <el-input v-model="this.cost" :maxlength="20" placeholder=""></el-input>
            </el-form-item>
          </div>
        </div>
        <div style="width: 100%">
          <div>
            <p style="font-weight: bold;font-size: 16px">线下订单账单</p>
          </div>
          <div style="width: 100%;display: flex;justify-content: start;flex-wrap: wrap;">
            <el-form-item label="线下订单总费用">
              <el-input v-model="form.offlineOrderFee" :maxlength="20" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="线下订单数量">
              <el-input v-model="form.offlineOrderNum" :maxlength="20" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="线下退单总费用">
              <el-input v-model="form.offlineRefundFee" :maxlength="20" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="线下退单数量">
              <el-input v-model="form.offlineRefundNum" :maxlength="20" placeholder=""></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  name: 'edit',
  components: {},
  props: ['row'],
  data () {
    return {
      form: null,
      treeData: [],
      agentTreeData: [],
      cost: ''
    }
  },
  async created () {
    this.initForm()
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async initForm () {
      if (this.row.settleId) {
        this.form = await this.$HTTP.ApiSettle.getSettleInfo(this.row.settleId)
        this.cost = this.form.onlineOrderFee - this.form.onlineRefundFee - this.form.serviceTotalFee
        console.log(this.cost);
      } else {
        this.form = {
          isLimitAgent: 0,
          isFeeAdjust: 0
        }
      }
      this.$nextTick(() => {
        if (this.$refs['form']) {
          this.$refs['form'].clearValidate()
        }
      })
    }
  }
}
</script>
<style>
  .batch-edit .el-tree-node {
    float: left;
  }

  .el-input.is-disabled .el-input__inner {
    background-color: #ffffff;
    color: #606266;
  }

  .el-form-item__label {
    color: #909399;
  }
</style>
